import { jsx as _jsx } from "react/jsx-runtime";
import { TS_EditableItemComponent } from '@nu-art/thunderstorm-frontend/editable-item';
import { Editor_DemoPatient } from '../Editor_DemoPatient/Editor_DemoPatient.js';
import { tsMCPDemoPatientValidator } from '@app/org-shared';
export class Editor_DeployDemoPatient extends TS_EditableItemComponent {
    render() {
        const editable = this.state.editable;
        const { mode, index, onDelete } = this.props;
        return _jsx(Editor_DemoPatient, { index: index, mode: mode, onDelete: onDelete, validator: tsMCPDemoPatientValidator, editable: editable, patientProps: [
                { name: 'label', label: 'Label' },
                { name: 'fhirPatient', label: 'FHIR Patient ID' },
                { name: 'encounterFhirId', label: 'Encounter ID' },
                { name: 'epicIdToken', label: 'Token JWT ()' },
                { name: 'gatewayUrl', label: 'FHIR Base Url' },
                { name: 'sdJwt', label: 'FHIR Token' },
                { name: 'emr', label: 'EMR Type (epic)' },
                { name: 'parentFrameUrl', label: 'Parent Window Url (AGL)' },
                { name: 'userName', label: 'User Name' },
                { name: 'userFullName', label: 'User Full Name' },
                { name: 'userFirstName', label: 'User First Name' },
                { name: 'userLastName', label: 'User Last Name' },
                { name: 'userEmail', label: 'User Email' },
                { name: 'userNPI', label: 'User NPI' },
                { name: 'patientFirstName', label: 'Patient First Name' },
                { name: 'patientLastName', label: 'Patient Last Name' },
                { name: 'encounterUniqueId', label: 'Encounter Unique ID' },
                { name: 'encounterDate', label: 'Encounter Date' },
            ] });
    }
}
//# sourceMappingURL=Editor_DeployDemoPatient.js.map